import { Fragment } from 'react'
import { Badge, CloseButton, Text } from '@leroy-merlin-br/backyard-react-ui'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import { useProfile } from 'catalog/hooks/use-profile'

import PickupIcon from '../Icons/Pickup'
import * as S from './styled'

const StockInfoHeader = ({ lm, productName, hideStock, lastUpdate }) => {
  const { profile } = useProfile()

  const isDriveThru = profile.regionDriveThru
  const region = profile.regionName

  return (
    <Fragment>
      <S.Header>
        <CloseButton onClick={hideStock} />
        <S.TitleWrapper>
          <S.Title>Disponibilidade de estoque</S.Title>
          <S.Subtitle>
            Selecione a loja que deseja retirar este produto
          </S.Subtitle>
        </S.TitleWrapper>
      </S.Header>

      {lastUpdate && (
        <p className="update-datetime">Atualizado em {lastUpdate}</p>
      )}

      {isDriveThru && (
        <S.AlertMessaWrapper>
          <AlertMessage
            type="info"
            title={`Retiradas via Drive-Thru em ${region}`}
          >
            Devido o cenário atual, em nossas lojas de{' '}
            <Text size="kilo" as="strong" bold noMargin>
              {region}
            </Text>{' '}
            as retiradas continuam funcionando através do{' '}
            <Text size="kilo" as="strong" bold noMargin>
              drive-thru
            </Text>
            , tomando todas as medidas para a segurança de todas as pessoas.{' '}
            <S.Link href="https://www.leroymerlin.com.br/institucional/funcionamento-lojas-leroy-merlin-covid">
              Saiba mais
            </S.Link>
          </AlertMessage>
        </S.AlertMessaWrapper>
      )}

      <S.AlertMessaWrapper>
        <AlertMessage type="warning" customIcon={PickupIcon}>
          A retirada de pedidos na loja ficará disponível{' '}
          <Text size="kilo" as="strong" bold noMargin>
            somente
          </Text>{' '}
          {isDriveThru && (
            <Text size="kilo" as="strong" bold noMargin>
              via drive-thru e{' '}
            </Text>
          )}
          <Text size="kilo" as="strong" bold noMargin>
            24h após a aprovação do pagamento.
          </Text>
        </AlertMessage>
      </S.AlertMessaWrapper>

      <S.ProductName as="div" bold noMargin>
        {productName}
      </S.ProductName>
      <Badge isLight>Cód: {lm}</Badge>
    </Fragment>
  )
}

export default StockInfoHeader
